import { css } from '@linaria/core';
import { baseTheme, breakpoints, theming } from 'styles/utils';
export const basicTemplateWrapper = "omponents__Navbar__components__Notifications__Templates__template_styles_ts-basicTemplateWrapper-bbdy56o";

require("./template.styles.linaria.module.css!=!../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./template.styles.ts");